import { getSessionStorage, setSessionStorage } from '@/storage';

const getFromStorage = (useCache, cachePath) =>
	useCache && cachePath && Object.keys(getSessionStorage(cachePath) ?? {}).length > 0;

export default function request({ url, cachePath, useCache = true, shouldCache, onSuccess = () => {} }) {
	if (getFromStorage(useCache, cachePath)) {
		console.log('Cache found...', cachePath);
		return onSuccess(getSessionStorage(cachePath));
	}
	console.log('Fetching...', url);

	const _request = new XMLHttpRequest();
	_request.onreadystatechange = () => {
		if (_request.readyState === XMLHttpRequest.DONE || _request.readyState === 4) {
			if (_request.status === 200) {
				try {
					const parsed = JSON.parse(_request.responseText);
					if (shouldCache(parsed)) {
						setSessionStorage(cachePath, parsed);
					}
					onSuccess(JSON.parse(_request.responseText), false, true);
				} catch (e) {}
			}
		}
	};
	_request.open('get', url, true);
	_request.send();
}
